import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Creators as AppCreators } from '../../reducers/app';
import { Types, Creators } from '../../reducers/customer';
import { signInUser } from '../../utils/cookiesUser';
import getState from '../../utils/getState';

function* changePasswordRequest({ payload, token }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);
    const domain = app.getIn(['config', 'domain']);

    const headers = { 'access-token': token };

    const data = yield call(customerAPI.changePassword, payload, headers, siteId);

    signInUser({ ...data, domain });

    yield put(Creators.changePasswordSuccess(data));
  } catch (error) {
    const formatted = formatError(error);
    yield put(Creators.changePasswordFailed(formatted));
    yield put(AppCreators.feedbackRequest({ open: true, message: formatted.message }));
  }
}

export default function* watch() {
  yield takeLatest(Types.CHANGE_PASSWORD_REQUEST, changePasswordRequest);
}
